module.exports = __webpack_public_path__ + "e839544d6d21d99dce836bf995f64199.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/dag-inge-aas.jpg
 ** module id = 404
 ** module chunks = 0
 **/